import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import styled from "styled-components";
import { Home } from "./components/Home/Home";
import { COLORS } from "./assets/constants/styles";
import { Header } from "./components/Header/Header";
import { initializeAmplitude } from "./helpers/analytics-helpers";
import { usePageTitle } from "./hooks/usePageTitle";
const App = () => {
  initializeAmplitude();
  usePageTitle();

  return (
    <AppContainer>
      <Header />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AppContainer>
  );
};

const AppContainer = styled.div`
  font-family: "Manrope", sans-serif;
  color: ${COLORS.black};
  font-weight: 500;
`;

export default App;
